import React from 'react';
import { Crown, ChevronRight } from 'lucide-react';
import { Capacitor } from '@capacitor/core';
import { useAuth } from '../context/AuthContext';
import { View } from '../types';

// Banner único compartido — antes existían dos versiones (una en App.tsx
// para el resto de la app, otra dentro de PetEnvironment.tsx para las
// pantallas de mascotas) que fueron divergiendo en estilo. Ahora ambas
// importan este mismo componente para que se vea idéntico en todos lados,
// como se pidió explícitamente.
export const usePremiumBannerVisible = () => {
    const { user } = useAuth();
    const isPremiumUser = user?.plan === 'premium' || (user as any)?.plan === 'family';
    return !!user && !isPremiumUser && Capacitor.isNativePlatform();
};

export const PremiumBanner: React.FC = () => (
    <button
        onClick={() => window.dispatchEvent(new CustomEvent('change-view', { detail: { view: View.SUBSCRIPTION } }))}
        className="w-full bg-gradient-to-r from-amber-500 to-orange-600 rounded-2xl px-4 py-3 flex items-center gap-3 shadow-lg shadow-orange-500/20 active:scale-[0.98] transition-all"
    >
        <Crown size={30} className="text-white shrink-0 drop-shadow-md premium-crown-jump" />
        <div className="flex-1 text-left min-w-0">
            <p className="text-white font-black uppercase text-xs leading-tight">Hazte Premium</p>
            <p className="text-white/85 text-[10px] font-bold leading-tight truncate">Mascotas ilimitadas, IA veterinaria y más</p>
        </div>
        <ChevronRight size={18} className="text-white/70 shrink-0" />
    </button>
);
